export const personalData = {
  name: 'Praveen Singh',
  profile: '/Praveen2.webp',
  designation: 'Software Developer',
  description:
    "Hello! I'm Praveen Singh, a passionate Full Stack Developer with expertise in creating dynamic, responsive web applications. With hands-on experience in both front-end and back-end development, I craft complete solutions that solve real-world problems. My journey started with a love for coding and problem-solving, which grew into a deep interest in technologies like React, Next.js, Node.js, and more. I enjoy working in collaborative environments, bringing ideas to life, and continuously learning in this ever-evolving field. Beyond coding, I love exploring new tools, contributing to open-source projects, and sharing knowledge with the developer community to inspire and grow together.",
  email: 'praveencdg@gmail.com',
  phone: '+91 9876543210',
  address: 'Sector 41, Chandigarh,India, 160036',
  github: 'https://github.com/Praveenskg',
  linkedIn: 'https://www.linkedin.com/in/praveenskg',
  twitter: 'https://twitter.com/its_praveen_s',
  facebook: 'https://www.facebook.com/Praveensald',
  devUsername: 'Praveenskg',
  resume: '/Praveen_Singh_Resume.pdf',
};
